import React from 'react';
import { useNavigate } from 'react-router-dom';
import { mapDeviceType } from './constants';
import { TableSkeleton } from './TableSkeleton';
import { TablePagination } from './TablePagination';
import NoDataAvailable from 'components/NoDataAvailable';

export const TableComponent = (props) => {
    const {
        data,
        sortField,
        setSortField,
        sortDirection,
        setSortDirection,
        columns,
        rowsHref, //TODO: remove and update other pages that were using it to use customer column component instead
        loading,
        currentPage,
        setCurrentPage,
        pageSize,
        totalItems,
        skeletonRows,
    } = props;

    const navigate = useNavigate();

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 1 ? -1 : 1);
        } else {
            setSortField(field);
            setSortDirection(1);
        }
    };

    const hasData = data?.length > 0;

    return (
        <div>
            <div className="overflow-x-scroll">
                {loading && (
                    <TableSkeleton columns={columns} rows={skeletonRows} />
                )}
                {!hasData && !loading && <NoDataAvailable />}
                {hasData && !loading && (
                    <table className={'w-full border-collapse text-sm'}>
                        <thead>
                            <tr>
                                {columns.map((column) => (
                                    <th
                                        key={column.Header}
                                        className="whitespace-nowrap px-5 py-3 text-left"
                                        onClick={() =>
                                            handleSort(column.accessor)
                                        }
                                    >
                                        {column.Header}
                                        {sortField === column.accessor &&
                                        !column.nosort &&
                                        sortDirection === 1
                                            ? '▲'
                                            : sortField === column.accessor &&
                                                !column.nosort &&
                                                sortDirection === -1
                                              ? '▼'
                                              : ''}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, idx) => (
                                <tr
                                    key={idx}
                                    onClick={() =>
                                        rowsHref && navigate(rowsHref(item))
                                    }
                                    className={`w-full p-3 ${
                                        rowsHref
                                            ? 'cursor-pointer transition-all hover:bg-muted hover:text-accent'
                                            : ''
                                    } ${item.Archived ? 'text-muted-foreground' : 'text-card-foreground'}`}
                                >
                                    {columns.map((column) => {
                                        const keyValue = item[column.accessor];
                                        // regular text cells
                                        let value = mapDeviceType(keyValue);

                                        // cells with custom components
                                        const customComponent =
                                            column.component;
                                        if (customComponent)
                                            value = customComponent(item);

                                        return (
                                            <td
                                                key={column.Header}
                                                className="whitespace-normal border-b px-5 py-3 sm:whitespace-nowrap"
                                            >
                                                {value}
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
            <TablePagination
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageSize={pageSize}
                totalItems={totalItems}
            />
        </div>
    );
};
